(function () {
  'use strict';

  angular
    .module('app.navsearch', []);
})();
